import React, { useEffect, useState } from 'react';
import { Container, Header, Icon, Menu, Dropdown } from 'semantic-ui-react';
import { referralActions } from '../../actions';
import './AgentPanel.css';
import EntryForm from '../../components/VEntry/EntryForm';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import { Switch, Route, useHistory, useRouteMatch, useLocation } from 'react-router-dom';
import { userActions, subscriptionActions } from '../../actions';
import { useTranslation } from 'react-i18next';
import Error from '../../components/Error/Error';
import ReferredList from '../../components/AgentTools/ReferredList';

const Login = () => {
  return (
    <div className="agentLogin">
      <img className="vibinoLogo" src={require('../../assets/images/vibinoLogoYellow.svg')} />
      <EntryForm form="login" />
    </div>
  );
};

const AgentPanel = props => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();
  const user = useSelector(state => state.authentication.user);
  const [authorized, setAuthorized] = useState(false);
  useEffect(() => {
    document.getElementsByTagName('html')[0].dataset.theme = 'light';
    if (_.get(user, 'role') === 'referral') {
      setAuthorized(true);
      dispatch(referralActions.getListOfReferred(_.get(user, 'referral')));
    }
  });
  const logout = () => {
    console.log('try logout');
    setAuthorized(false);
    dispatch(subscriptionActions.resetState());
    dispatch(userActions.logout());
    window.location.reload();
    // history.push('/agents');
  };

  const getReferredList = () => {
    dispatch(referralActions.getListOfReferred(_.get(user, 'referral')));
  };

  // const ReferredList = () => {
  //   const referredList = useSelector(state => state.referral.referredList);
  // };

  const userDDTrigger = (
    <span>
      <Icon name="user" /> {user && user.username}
    </span>
  );
  const userDDOptions = [
    {
      key: 'user',
      text: (
        <span>
          <strong>{user && user.username}</strong>
        </span>
      ),
      disabled: true,
    },
    { key: 'profile', text: 'پروفایل' },
    { key: 'settings', text: 'تنظیمات' },
    { key: 'sign-out', text: 'خروج', onClick: { logout } },
  ];

  const Panel = () => {
    const { path } = useRouteMatch();
    const history = useHistory();
    const location = useLocation();
    const [activeItem, setActiveItem] = useState(location.pathname);
    const handleItemClick = (e, { path }) => {
      setActiveItem(path);
      history.push(path);
    };
    return (
      <div className="mainContainer">
        <div className="menuContainer">
          <div className="menuHeader">
            <img className="vibinoLogo" src={require('../../assets/images/vibinoLogoYellow.svg')} />
          </div>
          <div className="userDD">
            <Dropdown trigger={userDDTrigger}>
              <Dropdown.Menu scrolling className="profileMenu">
                {/* <Dropdown.Item
                  key="1"
                  text={t('accountSettings')}
                // onClick={() => history.push(`${url}/account-setting`)}
                /> */}
                {/* <Dropdown.Item key="2" text={t('help')} /> */}
                <Dropdown.Item key="3" text={t('logout')} onClick={logout} />
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <Menu className="panelMenu" size="large" pointing vertical>
            <Container>
              <Menu.Item
                as="a"
                onClick={handleItemClick}
                path="/agents"
                active={activeItem === '/agents'}
              >
                داشبورد
              </Menu.Item>
              <Menu.Item
                as="a"
                onClick={handleItemClick}
                path="/agents/users"
                active={activeItem === '/agents/users'}
              >
                کاربرها
              </Menu.Item>
              <Menu.Item as="a">کدهای من</Menu.Item>
            </Container>
          </Menu>
        </div>
        <div className="bodyContainer">
          <div className="content">
            <Switch>
              <Route path={`/agents`} exact>
                <span>Dashboard</span>
              </Route>
              <Route path={`/agents/users`} component={ReferredList} />
              <Route path="*" render={() => <Error error={'404'} redirectTo={'support'} />} />
            </Switch>
          </div>
        </div>
      </div>
    );
  };

  return <div className="agentPanel">{!authorized ? <Login /> : <Panel />}</div>;
};

export default AgentPanel;
